import { h, Component } from 'preact';
import { BaseField } from '../BaseField';

import { bind, memoize, debounce } from 'decko';
import TextField from 'preact-material-components/TextField';
import FormField from 'preact-material-components/FormField';

import { ITextBoxProps, ITextBoxState } from './ITextBox';

//let style = require('./style.css');

export class TextBox extends BaseField<ITextBoxProps, ITextBoxState> {

    constructor(props: ITextBoxProps, ctx) {
        super(props, ctx);
        this.setState({
            value: props.value
        });
    }

    @bind
    public onChange(evt) {
        var value = evt.target.value;
        this.setState({ value: value });
        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {
        return (
            <FormField class={this.props.class}>
                <TextField id={this.props.name} name={this.props.name} label={this.props.label} value={this.state.value} onInput={this.onChange}></TextField>
            </FormField>
        );
    }
}




// WEBPACK FOOTER //
// ./components/forms/fields/textBox/TextBox.tsx